import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { CrosshairSimple, SignOut, List, ChartBar, ShieldCheck } from "@phosphor-icons/react";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!user) { setIsAdmin(false); return; }
    api.get("/admin/me").then(() => setIsAdmin(true)).catch(() => setIsAdmin(false));
  }, [user]);

  return (
    <header className="sticky top-0 z-40 bg-[#0D0D0D] border-b border-[#1A1A1A]" data-testid="app-nav">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-3 group" data-testid="nav-logo">
          <div className="w-8 h-8 bg-[#FF3366] flex items-center justify-center">
            <CrosshairSimple size={20} weight="bold" color="#fff" />
          </div>
          <div className="leading-none">
            <div className="font-heading font-black uppercase tracking-tighter text-lg">Systemic Friction</div>
            <div className="text-[10px] font-mono-sf uppercase tracking-[0.25em] text-neutral-500">The Consumer Equalizer</div>
          </div>
        </Link>

        <nav className="flex items-center gap-2">
          <Link
            to="/wins"
            className="hidden sm:flex items-center gap-2 px-4 h-10 border border-[#00FFCC]/30 hover:bg-[#00FFCC]/10 hover:text-[#00FFCC] text-xs font-mono-sf uppercase tracking-[0.2em] transition-colors text-[#00FFCC]"
            data-testid="nav-wins"
          >
            <ShieldCheck size={14} weight="bold" /> Wall
          </Link>
          {user ? (
            <>
              <Link
                to="/dashboard"
                className="hidden md:flex items-center gap-2 px-4 h-10 border border-[#1A1A1A] hover:bg-[#1A1A1A] text-xs font-mono-sf uppercase tracking-[0.2em] transition-colors"
                data-testid="nav-dashboard"
              >
                <List size={14} weight="bold" /> Cases
              </Link>
              {isAdmin && (
                <Link
                  to="/admin/analytics"
                  className="hidden md:flex items-center gap-2 px-4 h-10 border border-[#00FFCC]/40 hover:bg-[#00FFCC]/10 hover:text-[#00FFCC] text-xs font-mono-sf uppercase tracking-[0.2em] transition-colors text-[#00FFCC]"
                  data-testid="nav-admin"
                >
                  <ChartBar size={14} weight="bold" /> Admin
                </Link>
              )}
              <span className="hidden md:block text-xs font-mono-sf uppercase tracking-wider text-neutral-500 px-3" data-testid="nav-user-email">
                {user.email}
              </span>
              <button
                onClick={() => { logout(); navigate("/"); }}
                className="flex items-center gap-2 h-10 px-4 border border-[#1A1A1A] hover:border-[#FF3366] hover:text-[#FF3366] text-xs font-mono-sf uppercase tracking-[0.2em] transition-colors"
                data-testid="nav-logout-btn"
              >
                <SignOut size={14} weight="bold" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="h-10 px-4 flex items-center text-xs font-mono-sf uppercase tracking-[0.2em] hover:text-[#FF3366] transition-colors" data-testid="nav-login-link">
                Login
              </Link>
              <Link to="/register" className="h-10 px-5 flex items-center bg-[#FF3366] hover:bg-[#FF5248] text-white text-xs font-mono-sf uppercase tracking-[0.2em] font-semibold transition-colors" data-testid="nav-register-link">
                Deploy
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
